const isBypassMode = Boolean(import.meta.env.VITE_BYPASS_MODE) ?? false;

export default {
  methods: {
    userHasPrivilege(privileges) {
      if (isBypassMode) {
        return true;
      }

      if (!privileges?.length) {
        return true;
      }

      const roleAccess = this.$store.getters['authModule/roleAccess'];
      return privileges.every((p) => roleAccess(p));
    }
  }
};
